import { fontHeadings } from "../../../../enums/font";
import { loadFonts } from "../../../../utils/LoadSiteFonts";
import { IColorOverride } from "../../interfaces/IColorOverride";
import { overrideColorsToCssVars } from "../../utils/overrideColorsToCssVars";
import styles from "./RelaxedByHand.module.scss";

export interface IProps {
    eventLogo: IEventLogoRelaxedByHand;
    type: "SITE" | "PRINT";
    cssVarsOnly: string;
}

export interface IPropsDemo {
    type: "DEMO";
    cssVarsOnly: string;
}

export interface IEventLogoRelaxedByHand {
    name: "RelaxedByHand";
    name1: string;
    name2: string;
    colorText: IColorOverride;
}

export const RelaxedByHand = (props: IProps | IPropsDemo) => {
    const eventLogo: Omit<IEventLogoRelaxedByHand, "name"> =
        props.type !== "DEMO"
            ? props.eventLogo
            : {
                  name1: "Mathilda",
                  name2: "Jonas",
                  colorText: { override: false, color: null },
              };

    const fontFamilyNames = fontHeadings[21];

    loadFonts([{ font: fontFamilyNames, type: "ONLY_400" }]);
    return (
        <div
            className={`${styles.wrapper} ${styles[props.type]} ${props.cssVarsOnly}`}
            style={overrideColorsToCssVars([{ name: "text", colorOverride: eventLogo.colorText }])}
        >
            <div className={styles.namesWrapper} style={{ fontFamily: fontFamilyNames }}>
                <div>{eventLogo.name1}</div>
                <div>
                    <span className={styles.combinator}>+</span>
                    {eventLogo.name2}
                </div>
            </div>
        </div>
    );
};
